module.exports = __webpack_public_path__ + "4a561b2104fb69aceb1537e7f9e4d1bd.png";